import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
/**
 * Converts from the union type of Property | PropertyRecordType to Property
 *
 * @param definition A PropertyRecord or Property
 * @returns Either the definition passed in if it was already a POJO property
 * definition or the result of toJS if the definition was a PropertyRecord.
 */

export const normalizePropertyDefinition = definition => {
  if (definition instanceof PropertyRecord) {
    return definition.toJS();
  }

  return definition;
};